(function($) {
  var $form = $('#contact_form');
  if ( !$form.length )
    return;

  const WD = new WebsiteData();

  var _form = $form.get(0);
  var $recaptcha = $form.find('.g-recaptcha');
  var $elms = $form.find('[data-ajax-append]');

  // Init recaptcha when form is focused
  $form.on('focus', 'input, textarea, select, button', event => {
    if (typeof window.CustomRenderRecaptcha !== "undefined") {
      window.CustomRenderRecaptcha()
    }
  })

  // Add country option to select
  $elms.each((i, el) => {
    var source = el.getAttribute('data-ajax-append');
    $.get({
      url: source,
      success(data) {
        el.insertAdjacentHTML('beforeend', data);
      }
    })
  });

  // Validate form and excute recaptcha if passed
  var validated;
  $.getScript(local.templateurl + '/node_modules/jquery-validation/dist/jquery.validate.min.js', function() {
    validated = $form.validate({
      validClass: 'is-valid',
      errorClass: 'is-invalid',
      errorPlacement: function(error, element) {
        error.addClass('invalid-feedback')
        error.appendTo( element.parent() )
      },
      ignore: '.ignore',
      rules: {
        email: 'required',
        verify_email: {
          equalTo: '#email'
        }
      },
      messages: {
        verify_email: {
          equalTo: 'Your email address not match'
        }
      },
      submitHandler() {
        grecaptcha.execute( $recaptcha.attr('data-index') )
      }
    })
  })

  // Register contact sendding function to global
  if (window.ContactFormSubmit === undefined) {
    window.ContactFormSubmit = function(token) {
      if (token === undefined) {
        alert('You need to verify recaptcha');
        return
      }

      $form.find('[type=submit]')
        .addClass('btn-loading')
        .prop('disabled', true)

      var data = $form.serializeArray();
      var dataobj = {};
      data.forEach(items => {
        dataobj[items['name']] = items['value'];
      });

      var $name = `${dataobj.prefix} ${dataobj.first_name} ${dataobj.last_name}`
      var $email = dataobj.email;
      var $phone = dataobj.phone;
      var $countryCode = dataobj.country;
      var $countryName = $form.find('[name=country] > option:selected').text();
      var $message = dataobj.message;

      var formdata = new FormData(_form)
      formdata.append('country_name', $countryName)

      var wpmail = $.post({
        url: local.ajaxurl,
        data: formdata,
        processData: false,
        contentType: false,
      })

      wpmail.done(res => {
        if (res.success) {
          $form.removeClass('was-validated');
          $form.find('input, select, button').each(function() {
            $(this).blur();
            $(this).removeClass('is-valid is-invalid');
          })
          $form[0].reset()
          validated.resetForm()
          popupAlert( res.data.message, 'success' );
        } else {
          popupAlert( res.data.message, 'error' );
        }
      })

      wpmail.error(xhr => {
        popupAlert( local.contact.i18n['failed-message'], 'error');
      })

      wpmail.always(() => {
        grecaptcha.reset($recaptcha.attr('data-index'))
        $form.find('[type=submit]')
          .removeClass('btn-loading')
          .prop('disabled', false)
      })

      if (local.websiteDataAPI.api_contact) {
        WD.post({
          formKey: local.websiteDataAPI.api_contact,
          name: $name,
          email: $email,
          phone: $phone,
          countryCode: $countryCode,
          countryName: $countryName,
          message: $message
        }, {
          done() {
            console.log('done');
          },
          fail() {
            console.log('fail');
          }
        })
      }
    }
  }

  function popupAlert(msg, state) {
    $.magnificPopup.open({
      type: 'inline',
      items: {
        src: `<div class="popup-contact__content popup-contact__content--${state}">
          ${msg}
          <button class="mfp-close" onclick="jQuery.magnificPopup.instance.close()"><i class="fal fa-lg fa-times-circle"></i></button>
        </div>`
      },
      removalDelay: 500,
      mainClass: 'mfp-scale-up popup-contact'
    })
  }
})(jQuery);